import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, PopoverModal } from 'components/UI'
import ReportExportMenu from 'components/PageComponents/DataHub/Report/components/ReportExportMenu'
// context
import { ReportAPIContext } from 'containers/Report/layers/API'
// themes
import { colors } from 'themes'

// constants
const BUTTON_STYLE = {
  color: colors.purple300,
  height: '40px'
}

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'center' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'center' as const
  },
  PaperProps: {
    style: { marginTop: '24px' }
  }
}

const ExportReportButton: React.FC = () => {
  const { isExporting } = React.useContext(ReportAPIContext)

  return (
    <PopoverModal
      {...MODAL_PROPS}
      trigger={
        <Button
          isLoading={isExporting}
          layout={BUTTON_LAYOUTS.DARK_BLUE}
          shadowLess
          style={BUTTON_STYLE}
          type={'button'}>
          Export
        </Button>
      }>
      {({ closePopup }) => <ReportExportMenu closePopup={closePopup} />}
    </PopoverModal>
  )
}

export default ExportReportButton
